import StyledInput from 'components/styledInput/StyledInput';
import ToolProviderList from 'components/toolProviders/ToolProviderList';
import { DEFAULT_TOOL_PROVIDER } from './templateFormData';
import { templateText } from './templateTexts';

/** The tools of a job description, and who provides each one. */
const TemplateToolsSection = ({ tools, toolOptions, onChange }) => {
  const selectedNames = tools.map((tool) => tool.name);

  const onNamesChange = (updated) => {
    const checkedNames = updated
      .filter((item) => item.checked)
      .map((item) => item.value);
    // Keep the provider already chosen for a tool that stays selected.
    onChange(
      checkedNames.map((name) => ({
        name,
        providedBy:
          tools.find((tool) => tool.name === name)?.providedBy ||
          DEFAULT_TOOL_PROVIDER,
      }))
    );
  };

  return (
    <div className="flex flex-col gap-4">
      <StyledInput
        type="selectMultipleCheckbox"
        isSearchable
        label={templateText('tools.label')}
        value={selectedNames.length > 0 ? selectedNames.join(', ') : '-'}
        list={toolOptions.map((name) => ({
          value: name,
          label: name,
          checked: selectedNames.includes(name),
        }))}
        onChange={onNamesChange}
        dropdownFullWidth
      />
      <ToolProviderList tools={tools} onChange={onChange} />
    </div>
  );
};

export default TemplateToolsSection;
